function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Fluxo de Processo");

var SvgWorkflow = function SvgWorkflow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, React.createElement("path", {
    d: "M83.1,42.78H67.43a.75.75,0,0,0-.75.75v8.94a.75.75,0,0,0,.75.75H83.1a.75.75,0,0,0,.75-.75V43.53A.75.75,0,0,0,83.1,42.78Zm-.57,9a.64.64,0,0,1-.63.64H68.63a.64.64,0,0,1-.63-.64V44.22a.64.64,0,0,1,.63-.64H81.9a.64.64,0,0,1,.63.64Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M28.57,42.78H12.9a.75.75,0,0,0-.75.75v8.94a.75.75,0,0,0,.75.75H28.57a.75.75,0,0,0,.75-.75V43.53A.75.75,0,0,0,28.57,42.78Zm-14.91,6.5h-.38V46.72h.38Zm.85,0h-.38V46.72h.38Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M46.75,42.78H31.07a.76.76,0,0,0-.75.75v8.94a.76.76,0,0,0,.75.75H46.75a.76.76,0,0,0,.75-.75V43.53A.76.76,0,0,0,46.75,42.78Zm-14.92,6.5h-.38V46.72h.38Zm.85,0H32.3V46.72h.38Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M64.93,42.78H49.25a.76.76,0,0,0-.75.75v8.94a.76.76,0,0,0,.75.75H64.93a.76.76,0,0,0,.75-.75V43.53A.76.76,0,0,0,64.93,42.78ZM50,49.28h-.38V46.72H50Zm.85,0h-.38V46.72h.38Z",
    style: {
      fill: "#ccc"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWorkflow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/WORKFLOW.8a9b0bec.svg";
export { ForwardRef as ReactComponent };